import { useLayouts } from "@hooks/useLayouts";
import { usePublicTemplates } from "@hooks/usePublicTemplates";
import { useTemplates } from "@hooks/useTemplates";
import AssetPlayer from "./AssetPlayer";
import { useContentPlayer } from "./hooks/ContentPlayerProvider";
import { cn, Playlist, PlaylistItem } from "./imports";
import LayoutPlayer from "./LayoutPlayer";
import VideoPlayer from "./VideoPlayer";

export const luxonDateFormat = "yyyy-LL-dd, HH:mm";

export interface PlaylistGridProps extends React.ComponentProps<"div"> {
  playlist: Playlist;
}

export default function PlaylistGrid({
  playlist,
  className,
  ...props
}: PlaylistGridProps) {
  const { loading } = useContentPlayer()

  if (!playlist) return <>{loading}</>

  if (!playlist.items) return null

  return (
    <div
      className="h-full w-full flex items-center justify-center flex-wrap overflow-clip gap-1"
    >
      {playlist.items.toSorted(p => p.playOrder).map(item => <div
        className={cn("size-12 flex-grow", className)}
        {...props}
        key={item.id}>
        <Item {...item} />
      </div>)}
    </div>
  );
}

function Item(item: PlaylistItem) {
  const { layouts: _layouts } = useLayouts()
  const { templates } = useTemplates()
  const { templates: publicTemplates } = usePublicTemplates()
  const layouts = [..._layouts, ...templates, ...publicTemplates]

  switch (item?.type) {
    case "asset":
      return <AssetPlayer
        key={`asset_${item.id}`}
        asset={item}
      />;
    case "video":
      <VideoPlayer
        key={`video_${item.id}`}
        url={item?.url ?? ""}
      />
    case "layout":
    case "template":
      const layout = layouts.find(l => l.id === item.id)
      if (!layout) return null
      return <LayoutPlayer
        key={`layout_${layout.id}`}
        layoutInfo={layout}
        muted
      />
  }
}
